import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import ForgotPasswordForm from "../../components/auth/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="var(--color-bg)"
      px={4}
      py={12}
    >
      <ForgotPasswordForm />
    </Flex>
  );
};

export default ForgotPasswordPage;